import React, { useState } from "react";
import axios from "axios";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/ForgotPassword.css";
function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");

        try {
            
            const response = await axios.post(
                "/api/userregistration/forgot-password",
                {
                    UserID: email
                }
            );
           
            setMessage(response.data.message);

        } catch (err) {

            setError(
                err.response?.data?.message || "Something went wrong."
            );

            console.log(err.response);
        }
    };
    return (
        <div className="wrapper1">
            <Card className="loginContainer">
                <Card.Body>

                    <div className="logo-container">
                        <img
                            src={require("../assets/Mindteck Logo.png")}
                            alt="Mindteck Logo"
                            className="logo"
                        />
                    </div>

                    <h3>
                        <b>Vendor Management System</b>
                    </h3>

                    <hr />

                    <p className="instruction">
                        Please provide your username (Email ID). A new password
                        will be sent to your registered email address.
                    </p>

                    <p className="note">
                        <strong>Note:</strong> The "Forgot Password"
                        functionality is available only for valid vendors who
                        are already registered in the VMS system.
                        <br />
                        <br />
                        This is not for Mindteck users. Mindteck users are
                        requested to use the{" "}
                        <a
                            href="https://tms.mindteck.com"
                            target="_blank"
                            rel="noreferrer"
                        >
                            TMS Portal
                        </a>{" "}
                        to reset their password.
                    </p>

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Control
                                type="email"
                                placeholder="Enter UserId"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>

                        {error && (
                            <Alert variant="danger">{error}</Alert>
                        )}

                        {message && (
                            <Alert variant="success">{message}</Alert>
                        )}

                        <Button
                            type="submit"
                            className="submitBtn w-100"
                        >
                            Submit
                        </Button>
                    </Form>

                    <div className="text-center mt-4">
                        <Link to="/login">
                            Back to Login Page
                        </Link>
                    </div>

                </Card.Body>
            </Card>
        </div>
    );
}

export default ForgotPassword;